if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const target = document.getElementById('rebuy-cart');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-hidden") {
          const isHidden = target.getAttribute("aria-hidden") === "true";

          if (!isHidden) {
            handleCpOnCartDrawer();
            console.log("open mini cart");
          } else {
            console.log("close mini cart");
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  }, 5000);

  setTimeout(() => {
    const target = document.querySelector('.Search__Results');
    if (!target) return;

    const observer = new MutationObserver((mutations) => {
      for (let mutation of mutations) {
        if (mutation.attributeName === "aria-hidden") {
          const isHidden = target.getAttribute("aria-hidden") === "true";

          if (!isHidden) {
            console.log("open search");
            window.dispatchEvent(new Event("scroll"));
          }
        }
      }
    });

    observer.observe(target, {
      attributes: true,
      attributeFilter: ["aria-hidden"]
    });
  }, 1000);
}

const handleCpOnCartDrawer = () => {
  fetch('/cart.js').then(response => response.json()).then(data => {
    console.log("data", data)
      for (let i = 0; i < data.items.length; i++) {
        const item = data.items[i];
        console.log(`item ${[i + 1]}`, item)
        const nodes = document.querySelectorAll(".rebuy-cart__flyout-item-info");

        nodes.forEach(node => {
            const titleNode = node.querySelector(".rebuy-cart__flyout-item-product-title");
            const variantNode = node.querySelector(".rebuy-cart__flyout-item-variant-title");

            if (
                titleNode && titleNode.textContent.includes(item.product_title) ||
                variantNode && variantNode.textContent.includes(item.variant_title)
            ) {
                const moneyNode = node.querySelector(".rebuy-money");
                if (moneyNode) {
                    moneyNode.setAttribute("bss-b2b-cart-item-key", item.key);
                    moneyNode.setAttribute("bss-b2b-final-line-price", "");
                }
            }
        });

      }

    const subtotalNode = document.querySelector(".rebuy-cart__flyout-subtotal-amount");
    if (subtotalNode) {
        subtotalNode.setAttribute("bss-b2b-cart-total-price", "");
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    const checkBtnInterval = setInterval(() => {
      const btn = document.querySelector(".rebuy-button.rebuy-cart__checkout-button");
      if (btn) {
        const newBtn = btn.cloneNode(true);
        newBtn.setAttribute("type", "button");
        btn.parentNode.replaceChild(newBtn, btn);

        // new event
        newBtn.addEventListener("click", function(e) {
          e.preventDefault();
          console.log("Checkout clicked");
          BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
        });
      }
    }, 500);
  }

  const cartTrigger = document.querySelector('a[data-drawer-id="sidebar-cart"]');
  if (!cartTrigger) return;

  // first disable
  cartTrigger.style.pointerEvents = "none";
  cartTrigger.style.opacity = "0.5";
  cartTrigger.style.cursor = "not-allowed";

  // after 5s enable
  setTimeout(() => {
    cartTrigger.style.pointerEvents = "auto";
    cartTrigger.style.opacity = "1";
    cartTrigger.style.cursor = ""; 
    console.log("Cart drawer enabled");
  }, 4500);

});